import type { Replay } from '@/shared/model/types/replay';
import type { Size as BasicSize } from '@/shared/model/types';

export type Size = Extract<BasicSize, 'SM' | 'MD'>;

export enum Action {
  COPY,
  EDIT,
  DELETE,
  NONE
}

export enum DropdownItemType {
  ITEM,
  DIVIDER,
}

export type DropdownItem = {
  type: DropdownItemType;
  event: Action;
  label?: string;
  role?: string;
  icon?: string;
};

export type ReplayDetails = Pick<Replay, 'id' | 'name' | 'accountName'>;
